import { useMutation } from 'react-query';
import Customers from '../../services/Customers';
import { ICreateCustomerPhotoConsent } from '../../types/Patient';

export const useCreateCustomerPhotoConsent = () =>
  useMutation(({ patientId, serviceVisitId, signatureImage, patientName }: ICreateCustomerPhotoConsent) =>
    Customers.createCustomerPhotoConsent({ patientId, serviceVisitId, signatureImage, patientName })
  );
